import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useCrm } from "@/context/CrmContext";
import { MeetingRow } from "@/components/MeetingRow";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

const TABS = [["PENDING_DISPOSITION", "Pending outcome"], ["UPCOMING", "Upcoming & live"], ["CLOSED", "Dispositioned"]];

export default function Meetings() {
  const { tick, openDisposition } = useCrm();
  const [tab, setTab] = useState("PENDING_DISPOSITION");
  const [items, setItems] = useState(null);
  useEffect(() => { setItems(null); api.get("/meetings", { params: { state: tab } }).then((r) => setItems(r.data)); }, [tab, tick]);
  return (
    <div className="space-y-5">
      <div><h1 className="font-display text-2xl font-bold text-[#151515]">Meetings</h1><p className="text-sm text-neutral-500">Deterministic lifecycle — every elapsed meeting needs an explicit outcome.</p></div>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="bg-white">{TABS.map(([k, t]) => <TabsTrigger key={k} value={k} data-testid={`meetings-tab-${k.toLowerCase()}`}>{t}</TabsTrigger>)}</TabsList>
      </Tabs>
      <div data-testid="meetings-list" className="grid gap-3 md:grid-cols-2">
        {items === null && <p className="text-neutral-400">Loading…</p>}
        {items?.length === 0 && <p data-testid="meetings-empty" className="col-span-full rounded-2xl border border-dashed border-neutral-200 p-8 text-center text-sm text-neutral-400">Nothing here.</p>}
        {items?.map((m) => <MeetingRow key={m.id} m={m} showLead onLog={() => openDisposition(m.lead, m)} />)}
      </div>
    </div>
  );
}
